var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medical-insurance-tab"},[_c('div',{staticClass:"empty-data-container"},[_c('div',{staticClass:"empty-icon"},[_c('i',{staticClass:"el-icon-first-aid-kit"})]),_c('div',{staticClass:"empty-text"},[_vm._v("暂无医保数据")]),_c('div',{staticClass:"empty-description"},[_vm._v("当前没有相关的医保信息记录")])])])
}]

export { render, staticRenderFns }